import type { TOC } from '@ember/component/template-only';
import { PrismNumberInput } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { NUMBER_INPUT_MAX_VALUE } from 'lumen/utils/constants/pricing-assistant-constants';

interface HotelPricingAssistantTableModalsEditOverrideModalDiscountOverrideFormSignature {
  Args: {
    discountOverrideNewValueError: {
      errorMessage: string;
      hasErrors: boolean;
      showErrors: boolean;
    };
    discountPlaceholder?: string;
    onValueChange: (value: number | null) => Promise<void>;
    value: number | null;
  };
}

const DiscountOverrideForm = <template>
  <div
    class="override-modal__price-container"
    data-test-id="discount-override-new-value-container"
  >
    <PrismNumberInput
      @errorMessage={{@discountOverrideNewValueError.errorMessage}}
      @hasErrors={{@discountOverrideNewValueError.showErrors}}
      @inlineLabel="%"
      @isTouched={{true}}
      @label={{t "pricing_assistant.discount_override.input.label"}}
      @max={{NUMBER_INPUT_MAX_VALUE}}
      @min={{0}}
      @onValueChange={{@onValueChange}}
      @placeholder={{@discountPlaceholder}}
      @removePadding={{true}}
      @value={{@value}}
      data-test-id="discount-override-new-value-input"
    />
  </div>
</template> satisfies TOC<HotelPricingAssistantTableModalsEditOverrideModalDiscountOverrideFormSignature>;

export default DiscountOverrideForm;
